module.exports = __webpack_public_path__ + "img/service-3.96f36d9f.png";